import React, { useState } from 'react';
import { auth, functions } from '../firebase/config';
import { httpsCallable } from 'firebase/functions';
import Header from '../components/Header';

const VerifyEmailPage = ({ navigateTo, currentPage }) => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleResendVerification = async () => {
        setIsLoading(true);
        setMessage('');
        setError('');
        try {
            const sendVerificationEmail = httpsCallable(functions, 'sendVerificationEmail');
            const result = await sendVerificationEmail();
            setMessage(result.data.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-8">
            <Header title="Verify Your Email" navigateTo={navigateTo} currentPage={currentPage} />
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Check Your Inbox</h2>
                <p className="text-gray-600 mb-6">
                    We've sent a verification link to **{auth.currentUser?.email}**. Please click the link in that email to continue.
                </p>
                {message && <p className="text-green-500 mb-4">{message}</p>}
                {error && <p className="text-red-500 mb-4">{error}</p>}
                <div className="flex justify-center items-center space-x-4">
                    <button 
                        onClick={handleResendVerification} 
                        disabled={isLoading}
                        className="px-6 py-2 font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                    >
                        {isLoading ? 'Sending...' : 'Resend Verification Email'}
                    </button>
                    <button 
                        onClick={() => window.location.reload()}
                        className="px-6 py-2 font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                    >
                        I've Verified
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailPage;